import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import usePageTracking from "../../../hooks/usePageTracking";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";
import { Button, Card, Form } from "react-bootstrap";
import {
  removeFromCart,
  updateCartQuantity,
} from "../../../redux/slices/shopSlice";
import { useNavigate } from "react-router-dom";
import "./cart.scss";
import { FiArrowLeft } from "react-icons/fi";

const Cart = () => {
  const dispatch = useDispatch();

  usePageTracking("CART");
  useEffect(() => {
    dispatch(activityStart({ page_name: "CART", platform: "web" }));
    return () => dispatch(activityEnd({ page_name: "CART" }));
  }, [dispatch]);
  const navigate = useNavigate();

  const { cartItems } = useSelector((state) => state.shop);

  const subtotal = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0,
  );

  return (
    <div className="cart-wrapper">
      {/* <h2 className="cart-title">Your Cart</h2> */}
      <div className="app-page-title">
        <div className="page-title-heading d-flex align-items-center">
          <FiArrowLeft
            size={40}
            className="icon cursor-pointer"
            onClick={() => navigate("/shop/products")}
          />
          <h3 className="page-title">Your Cart</h3>
        </div>
      </div>

      <div className="cart-layout">
        {/* LEFT SIDE */}
        <div className="cart-left">
          <Card className="cart-card">
            <Card.Body>
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Subtotal</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {cartItems.map((item) => (
                    <tr key={item.id}>
                      <td className="products-info">
                        <img src={item.images?.[0]?.src} alt="" />
                        <span>{item.name}</span>
                      </td>

                      <td className="products-price" data-label="Price">${item.price}</td>

                      <td className="products-qty" data-label="Qty">
                        <div className="qty-control">
                          <button
                            onClick={() =>
                              dispatch(
                                updateCartQuantity({
                                  id: item.id,
                                  quantity: item.quantity - 1,
                                }),
                              )
                            }
                          >
                            -
                          </button>

                          <span>{item.quantity}</span>

                          <button
                            onClick={() =>
                              dispatch(
                                updateCartQuantity({
                                  id: item.id,
                                  quantity: item.quantity + 1,
                                }),
                              )
                            }
                          >
                            +
                          </button>
                        </div>
                      </td>

                      <td className="products-subtotal" data-label="Sub Total">${(item.price * item.quantity).toFixed(2)}</td>

                      <td className="products-button">
                        <button
                          className="remove-btn"
                          onClick={() => dispatch(removeFromCart(item.id))}
                        >
                          ×
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Coupon */}
              {/* <div className="coupon-section">
                <input type="text" placeholder="Coupon code" />
                <Button variant="primary">Apply coupon</Button>
              </div> */}

              {/* Continue Shopping */}
              <div className="continue-shopping">
                <Button
                  variant="primary"
                  onClick={() => navigate("/shop/products")}
                  className="continue-btn"
                >
                  <FiArrowLeft className="me-2" />
                  Continue Shopping
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>

        {/* RIGHT SIDE */}
        <div className="cart-right">
          <Card className="cart-total-card">
            <Card.Body>
              <h6>Cart totals</h6>

              <div className="total-rows">
                <span>Subtotal</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>

              <div className="total-rows">
                <span>Shipping</span>
                <span>Free shipping</span>
              </div>

              <div className="total-rows total">
                <span>Total</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>

              <Button
                className="checkout-btn"
                onClick={() => navigate("/shop/checkout")}
              >
                Proceed to checkout
              </Button>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Cart;
